// components/layouts/PrivateLayout.tsx
"use client";

import "./PrivateLayout.css";

const PrivateLayout = ({ children }: { children: React.ReactNode }) => {
  return (
    <>
      <main>
        {children}
      </main>
    </>
  );
};

export default PrivateLayout;